// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__12o2K","activeLink":"Navigation_activeLink__2rUFB Navigation_link__12o2K"};